(function ($) {
  $(document).ready(function () {
    $(document).on(
      "click",
      ".menu-header-navigation-container li",
      function () {
        $("header").addClass("bg-blue-grey").removeClass("bg-transparent");

        if ($(window).width() > 1199) {
          $(".sub-menu").hide().removeClass("in");
          $(
            ".menu-header-navigation-container, .menu-header-navigation-container a, .menu-header-navigation-container li"
          ).removeClass("active");
        }

        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          if ($(this).find(".sub-menu")) {
            $(this).find(".sub-menu").hide().removeClass("in");
          }
        } else {
          if ($(this).find(".sub-menu")) {
            $(this).find(".sub-menu").show().addClass("in");
          }
          $(this).addClass("active");
        }
      }
    );
    if ($(window).width() < 1200) {
      $(".menu-header-navigation-container").prepend(
        '<div class="font-trade-gothic-bold uppercase text-blue-grey flex justify-between items-center h-[60px] px-5 bg-white"><span>Menu</span><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6.5L6 18.5" stroke="#333E48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6.5L18 18.5" stroke="#333E48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
      );
      $(".menu-header-navigation-container").append(
        '<button class="bg-copper-gradient w-[calc(100%-40px)] mt-[60px] mx-5 mb-5 text-white uppercase py-4 px-6 h7">Book Now</button>'
      );
    }

    $(document).on("click", ".hamburger", function () {
      $(".menu-header-navigation-container").show();
    });

    $(document).on(
      "click",
      ".menu-header-navigation-container > div > svg",
      function () {
        $(".menu-header-navigation-container").hide();
      }
    );

    $(".sports-slider").owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: false,
      items: 4,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1050: {
          items: 4,
        },
      },
      navText: [
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.5L0.75 6L5.25 10.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 10.5L5.25 6L0.75 1.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      ],
    });

    $(".fixtures-slider").owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: false,
      items: 4,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1050: {
          items: 3,
        },
      },
      navText: [
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.5L0.75 6L5.25 10.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 10.5L5.25 6L0.75 1.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      ],
    });

    let tallestFixtureSliderElem = 0;

    $(".fixtures-slider .owl-item > div").each(function () {
      if ($(this).height() > tallestFixtureSliderElem) {
        tallestFixtureSliderElem = $(this).height();
      }
    });

    $(".fixtures-slider .owl-item > div").height(tallestFixtureSliderElem);

    $(".offers-slider").owlCarousel({
      loop: true,
      margin: 40,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 3,
        },
      },
      navText: [
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.5L0.75 6L5.25 10.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 10.5L5.25 6L0.75 1.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      ],
    });

    $(".gallery-slider").owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      dots: false,
      center: true,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 1.7,
        },
      },
      navText: [
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.5L0.75 6L5.25 10.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 10.5L5.25 6L0.75 1.5" stroke="#ffffff" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      ],
    });

    $(".three-card-slider").owlCarousel({
      loop: true,
      margin: 40,
      nav: true,
      dots: false,
      center: true,
      responsive: {
        0: {
          items: 1,
        },
        1000: {
          items: 3,
        },
      },
      navText: [
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.5L0.75 6L5.25 10.5" stroke="#274951" stroke-linecap="square" stroke-linejoin="round"/></svg>',
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 10.5L5.25 6L0.75 1.5" stroke="#274951" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      ],
    });

    $(".fixture-date-slider").owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 3,
          margin: 20,
        },
        900: {
          items: 5,
          margin: 40,
        },
        1200: {
          items: 9,
          margin: 40,
        },
      },
      navText: [
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.5L0.75 6L5.25 10.5" stroke="#274951" stroke-linecap="square" stroke-linejoin="round"/></svg>',
        '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 10.5L5.25 6L0.75 1.5" stroke="#274951" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      ],
    });

    $(document).on("click", ".scroll-to-section", function () {
      let sectionKey = $(this).attr("data-section-trigger");

      $("html, body").animate(
        {
          scrollTop: $("section:eq(" + sectionKey + ")").offset().top,
        },
        1000
      );
    });

    $(document).on("click", ".date-click", function () {
      let selectedDate = $(this).attr("data-date");
      let noEventsAvailable = true;

      if (selectedDate == "all") {
        $(".fixture-grid > div").show();
        noEventsAvailable = false;
      } else {
        $(".fixture-grid > div").each(function () {
          if ($(this).find(".fixture-date").text() != selectedDate) {
            $(this).hide();
          } else {
            $(this).show();
            noEventsAvailable = false;
          }
        });
      }

      if (noEventsAvailable) {
        $(".no-events-available").removeClass("hidden");
      } else {
        $(".no-events-available").addClass("hidden");
      }
    });
  });

  $(document).on("click", ".fixture-click, .book-button", function () {
    let venue = "";

    if ($(this).attr("data-venue")) {
      venue = $(this).attr("data-venue");
    }

    if ($("body").attr("data-post-type") == "venues") {
      venue = $("body").attr("data-venue");
    }

    $.ajax({
      url: "/admin/wp-admin/admin-ajax.php",
      data: {
        action: "get_booking_widget",
        venue: venue,
      },
      type: "POST",
      success: function (ret) {
        ret = JSON.parse(ret);
        $(".booking-widget-modal .booking-widget").html(ret);
        $(".booking-widget-modal").removeClass("hidden");
      },
    });

    $(".booking-widget-modal").removeClass("hidden");

    let year = $(this).attr("data-fixture-year");
    let month = parseInt($(this).attr("data-fixture-month")) - 1;
    let day = $(this).attr("data-fixture-day");
    let fixtureTitle = $(this).attr("data-fixture-title");

    let widget = window.DMN.BookingFormHelper.widgets[0];

    let bookingDate = new Date(year, month, day); // Month is 0-indexed, so 10 is November
    widget.setDate(bookingDate);

    widget.setNotes(fixtureTitle);
  });

  $(document).on("click", ".modal .modal-inner .close", function () {
    $(".modal").addClass("hidden");
    $(".booking-widget-modal .booking-widget").html("");
  });

  // Newsletter date input functionality
  const $dateInput = $("#newsletter-date");
  const $dateDisplay = $("#date-display");

  function updateDisplay() {
    if ($dateInput.val()) {
      const date = new Date($dateInput.val());
      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      $dateDisplay.text(formattedDate).removeClass("button-style");
    } else {
      $dateDisplay.text("Select date").addClass("button-style");
    }
  }

  $dateInput.on("change", updateDisplay);
  $dateDisplay.on("click", function () {
    $dateInput.focus().click();
  });
  updateDisplay(); // Set initial state

  document
    .getElementById("newsletter-signup")
    .addEventListener("input", function (event) {
      // Get all input fields except for the submit button and honeypot
      const inputs = this.querySelectorAll(
        'input:not([type="submit"]):not([name="location"])'
      );
      const select = this.querySelector("select");
      const checkbox = this.querySelector('input[type="checkbox"]');

      let allFilled = true; // Flag to check if all fields are filled

      // Check text inputs and email
      inputs.forEach((input) => {
        if (input.type === "checkbox") {
          if (!input.checked) {
            allFilled = false;
          }
        } else if (input.type === "date") {
          if (!input.value) {
            allFilled = false;
          }
        } else if (!input.value.trim()) {
          allFilled = false;
        }
      });

      // Check select field
      if (select && !select.value) {
        allFilled = false;
      }

      // Check checkbox
      if (checkbox && !checkbox.checked) {
        allFilled = false;
      }

      // Update submit button state
      const $submitButton = $("#ga__newsletter-submit");
      if (allFilled) {
        $submitButton
          .removeClass("cursor-not-allowed opacity-50")
          .addClass("cursor-pointer")
          .prop("disabled", false);
      } else {
        $submitButton
          .addClass("cursor-not-allowed opacity-50")
          .removeClass("cursor-pointer")
          .prop("disabled", true);
      }
    });

  // Newsletter form submission
  $(document).on("submit", "#newsletter-signup", function (e) {
    e.preventDefault();

    const $form = $(this);
    const $submitButton = $("#ga__newsletter-submit");
    const $errorContainer = $('<div class="error-messages"></div>');

    // Remove any existing messages
    $(".error-messages").remove();

    // Set loading state
    const originalButtonText = $submitButton.html();
    $submitButton.html(
      '<span class="inline-block relative top-[px] animate-spin rounded-full h-4 w-4 border-2 border-current border-t-transparent mr-2"></span> Submitting...'
    );
    $submitButton
      .prop("disabled", true)
      .addClass("opacity-50 cursor-not-allowed");

    // Get form data
    const formData = new FormData(this);

    // Add action for admin-ajax
    formData.append("action", "newsletter_signup");

    // Send AJAX request
    $.ajax({
      url: "/admin/wp-admin/admin-ajax.php",
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: function (response) {
        if (response.success) {
          // Redirect immediately
          window.location.href = response.data.redirect;
        } else {
          // Show error message(s)
          let errorHtml = "";
          if (Array.isArray(response.data.messages)) {
            errorHtml = response.data.messages.join("<br>");
          } else {
            errorHtml = response.data.message;
          }
          $errorContainer.html(errorHtml);
          $form.append($errorContainer);

          // Reset button state
          $submitButton.html(originalButtonText);
          $submitButton
            .prop("disabled", false)
            .removeClass("opacity-50 cursor-not-allowed");
        }
      },
      error: function (xhr, status, error) {
        // Show generic error message
        $errorContainer.html("An error occurred. Please try again later.");
        $form.append($errorContainer);

        // Log error details
        console.error("Form submission error:", {
          status: status,
          error: error,
          response: xhr.responseText,
        });

        // Reset button state
        $submitButton.html(originalButtonText);
        $submitButton
          .prop("disabled", false)
          .removeClass("opacity-50 cursor-not-allowed");
      },
    });
  });
})(jQuery);

jQuery(window).on("resize", function () {
  if (jQuery(window).width() > 1199) {
    jQuery(".menu-header-navigation-container .bg-white").remove();
    jQuery(".menu-header-navigation-container .bg-copper-gradient").remove();
  }
});
